/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
  '/': {
    get: {
      responses: {
        /** OK */
        200: unknown;
      };
    };
  };
  '/bairro': {
    get: {
      parameters: {
        query: {
          nome?: parameters['rowFilter.bairro.nome'];
          id?: parameters['rowFilter.bairro.id'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['bairro'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** bairro */
          bairro?: definitions['bairro'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          nome?: parameters['rowFilter.bairro.nome'];
          id?: parameters['rowFilter.bairro.id'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          nome?: parameters['rowFilter.bairro.nome'];
          id?: parameters['rowFilter.bairro.id'];
        };
        body: {
          /** bairro */
          bairro?: definitions['bairro'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/testada': {
    get: {
      parameters: {
        query: {
          testada_principal?: parameters['rowFilter.testada.testada_principal'];
          id_bairro?: parameters['rowFilter.testada.id_bairro'];
          id_lote?: parameters['rowFilter.testada.id_lote'];
          prncipal?: parameters['rowFilter.testada.prncipal'];
          id?: parameters['rowFilter.testada.id'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['testada'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** testada */
          testada?: definitions['testada'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          testada_principal?: parameters['rowFilter.testada.testada_principal'];
          id_bairro?: parameters['rowFilter.testada.id_bairro'];
          id_lote?: parameters['rowFilter.testada.id_lote'];
          prncipal?: parameters['rowFilter.testada.prncipal'];
          id?: parameters['rowFilter.testada.id'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          testada_principal?: parameters['rowFilter.testada.testada_principal'];
          id_bairro?: parameters['rowFilter.testada.id_bairro'];
          id_lote?: parameters['rowFilter.testada.id_lote'];
          prncipal?: parameters['rowFilter.testada.prncipal'];
          id?: parameters['rowFilter.testada.id'];
        };
        body: {
          /** testada */
          testada?: definitions['testada'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/view_imoveis_totais': {
    get: {
      parameters: {
        query: {
          id_imobiliario?: parameters['rowFilter.view_imoveis_totais.id_imobiliario'];
          id_lote?: parameters['rowFilter.view_imoveis_totais.id_lote'];
          id_imobiliario_pessoa?: parameters['rowFilter.view_imoveis_totais.id_imobiliario_pessoa'];
          id_pessoa?: parameters['rowFilter.view_imoveis_totais.id_pessoa'];
          id_bairro?: parameters['rowFilter.view_imoveis_totais.id_bairro'];
          cadastro?: parameters['rowFilter.view_imoveis_totais.cadastro'];
          inscricao_lote?: parameters['rowFilter.view_imoveis_totais.inscricao_lote'];
          ativo?: parameters['rowFilter.view_imoveis_totais.ativo'];
          inscricao_cadastral_lote?: parameters['rowFilter.view_imoveis_totais.inscricao_cadastral_lote'];
          inscricao_cadastral_imovel?: parameters['rowFilter.view_imoveis_totais.inscricao_cadastral_imovel'];
          ocupacao?: parameters['rowFilter.view_imoveis_totais.ocupacao'];
          area_terreno?: parameters['rowFilter.view_imoveis_totais.area_terreno'];
          acumulo_metrico?: parameters['rowFilter.view_imoveis_totais.acumulo_metrico'];
          testada_principal?: parameters['rowFilter.view_imoveis_totais.testada_principal'];
          calcada?: parameters['rowFilter.view_imoveis_totais.calcada'];
          limite?: parameters['rowFilter.view_imoveis_totais.limite'];
          irregularidade?: parameters['rowFilter.view_imoveis_totais.irregularidade'];
          tipo_insercao?: parameters['rowFilter.view_imoveis_totais.tipo_insercao'];
          zona_fiscal?: parameters['rowFilter.view_imoveis_totais.zona_fiscal'];
          setor_calculo?: parameters['rowFilter.view_imoveis_totais.setor_calculo'];
          nome?: parameters['rowFilter.view_imoveis_totais.nome'];
          patrimonio?: parameters['rowFilter.view_imoveis_totais.patrimonio'];
          situacao?: parameters['rowFilter.view_imoveis_totais.situacao'];
          pedologia?: parameters['rowFilter.view_imoveis_totais.pedologia'];
          topografia?: parameters['rowFilter.view_imoveis_totais.topografia'];
          geometria?: parameters['rowFilter.view_imoveis_totais.geometria'];
          quota_inundacao?: parameters['rowFilter.view_imoveis_totais.quota_inundacao'];
          inscricao_geo?: parameters['rowFilter.view_imoveis_totais.inscricao_geo'];
          unidade?: parameters['rowFilter.view_imoveis_totais.unidade'];
          unidade_avaliacao?: parameters['rowFilter.view_imoveis_totais.unidade_avaliacao'];
          numero_unidades_avaliacao?: parameters['rowFilter.view_imoveis_totais.numero_unidades_avaliacao'];
          pav_numero_total?: parameters['rowFilter.view_imoveis_totais.pav_numero_total'];
          cpf_cnpj?: parameters['rowFilter.view_imoveis_totais.cpf_cnpj'];
          proprietario?: parameters['rowFilter.view_imoveis_totais.proprietario'];
          logradouro?: parameters['rowFilter.view_imoveis_totais.logradouro'];
          numero?: parameters['rowFilter.view_imoveis_totais.numero'];
          complemento?: parameters['rowFilter.view_imoveis_totais.complemento'];
          bairro?: parameters['rowFilter.view_imoveis_totais.bairro'];
          cep?: parameters['rowFilter.view_imoveis_totais.cep'];
          ano_construcao?: parameters['rowFilter.view_imoveis_totais.ano_construcao'];
          pontuacao?: parameters['rowFilter.view_imoveis_totais.pontuacao'];
          padrao_acabamento?: parameters['rowFilter.view_imoveis_totais.padrao_acabamento'];
          tipologia?: parameters['rowFilter.view_imoveis_totais.tipologia'];
          tipo_uso?: parameters['rowFilter.view_imoveis_totais.tipo_uso'];
          disposicao?: parameters['rowFilter.view_imoveis_totais.disposicao'];
          estado_conservacao?: parameters['rowFilter.view_imoveis_totais.estado_conservacao'];
          fracao_ideal?: parameters['rowFilter.view_imoveis_totais.fracao_ideal'];
          area_tributavel?: parameters['rowFilter.view_imoveis_totais.area_tributavel'];
          estrutura?: parameters['rowFilter.view_imoveis_totais.estrutura'];
          material_predominante?: parameters['rowFilter.view_imoveis_totais.material_predominante'];
          revestimento_externo?: parameters['rowFilter.view_imoveis_totais.revestimento_externo'];
          pintura_externa?: parameters['rowFilter.view_imoveis_totais.pintura_externa'];
          cobertura?: parameters['rowFilter.view_imoveis_totais.cobertura'];
          esquadrias?: parameters['rowFilter.view_imoveis_totais.esquadrias'];
          equacao?: parameters['rowFilter.view_imoveis_totais.equacao'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['view_imoveis_totais'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
  };
  '/lote': {
    get: {
      parameters: {
        query: {
          id_bairro?: parameters['rowFilter.lote.id_bairro'];
          cadastro?: parameters['rowFilter.lote.cadastro'];
          inscricao_lote?: parameters['rowFilter.lote.inscricao_lote'];
          ativo?: parameters['rowFilter.lote.ativo'];
          inscricao_cadastral?: parameters['rowFilter.lote.inscricao_cadastral'];
          ocupacao?: parameters['rowFilter.lote.ocupacao'];
          area_terreno?: parameters['rowFilter.lote.area_terreno'];
          acumulo_metrico?: parameters['rowFilter.lote.acumulo_metrico'];
          testada_principal?: parameters['rowFilter.lote.testada_principal'];
          calcada?: parameters['rowFilter.lote.calcada'];
          limite?: parameters['rowFilter.lote.limite'];
          irregularidade?: parameters['rowFilter.lote.irregularidade'];
          tipo_insercao?: parameters['rowFilter.lote.tipo_insercao'];
          zona_fiscal?: parameters['rowFilter.lote.zona_fiscal'];
          setor_calculo?: parameters['rowFilter.lote.setor_calculo'];
          cpf_cnpj?: parameters['rowFilter.lote.cpf_cnpj'];
          nome?: parameters['rowFilter.lote.nome'];
          patrimonio?: parameters['rowFilter.lote.patrimonio'];
          logradouro?: parameters['rowFilter.lote.logradouro'];
          numero?: parameters['rowFilter.lote.numero'];
          complemento?: parameters['rowFilter.lote.complemento'];
          cep?: parameters['rowFilter.lote.cep'];
          situacao?: parameters['rowFilter.lote.situacao'];
          pedologia?: parameters['rowFilter.lote.pedologia'];
          topografia?: parameters['rowFilter.lote.topografia'];
          geometria?: parameters['rowFilter.lote.geometria'];
          quota_inundacao?: parameters['rowFilter.lote.quota_inundacao'];
          id?: parameters['rowFilter.lote.id'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['lote'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** lote */
          lote?: definitions['lote'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_bairro?: parameters['rowFilter.lote.id_bairro'];
          cadastro?: parameters['rowFilter.lote.cadastro'];
          inscricao_lote?: parameters['rowFilter.lote.inscricao_lote'];
          ativo?: parameters['rowFilter.lote.ativo'];
          inscricao_cadastral?: parameters['rowFilter.lote.inscricao_cadastral'];
          ocupacao?: parameters['rowFilter.lote.ocupacao'];
          area_terreno?: parameters['rowFilter.lote.area_terreno'];
          acumulo_metrico?: parameters['rowFilter.lote.acumulo_metrico'];
          testada_principal?: parameters['rowFilter.lote.testada_principal'];
          calcada?: parameters['rowFilter.lote.calcada'];
          limite?: parameters['rowFilter.lote.limite'];
          irregularidade?: parameters['rowFilter.lote.irregularidade'];
          tipo_insercao?: parameters['rowFilter.lote.tipo_insercao'];
          zona_fiscal?: parameters['rowFilter.lote.zona_fiscal'];
          setor_calculo?: parameters['rowFilter.lote.setor_calculo'];
          cpf_cnpj?: parameters['rowFilter.lote.cpf_cnpj'];
          nome?: parameters['rowFilter.lote.nome'];
          patrimonio?: parameters['rowFilter.lote.patrimonio'];
          logradouro?: parameters['rowFilter.lote.logradouro'];
          numero?: parameters['rowFilter.lote.numero'];
          complemento?: parameters['rowFilter.lote.complemento'];
          cep?: parameters['rowFilter.lote.cep'];
          situacao?: parameters['rowFilter.lote.situacao'];
          pedologia?: parameters['rowFilter.lote.pedologia'];
          topografia?: parameters['rowFilter.lote.topografia'];
          geometria?: parameters['rowFilter.lote.geometria'];
          quota_inundacao?: parameters['rowFilter.lote.quota_inundacao'];
          id?: parameters['rowFilter.lote.id'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_bairro?: parameters['rowFilter.lote.id_bairro'];
          cadastro?: parameters['rowFilter.lote.cadastro'];
          inscricao_lote?: parameters['rowFilter.lote.inscricao_lote'];
          ativo?: parameters['rowFilter.lote.ativo'];
          inscricao_cadastral?: parameters['rowFilter.lote.inscricao_cadastral'];
          ocupacao?: parameters['rowFilter.lote.ocupacao'];
          area_terreno?: parameters['rowFilter.lote.area_terreno'];
          acumulo_metrico?: parameters['rowFilter.lote.acumulo_metrico'];
          testada_principal?: parameters['rowFilter.lote.testada_principal'];
          calcada?: parameters['rowFilter.lote.calcada'];
          limite?: parameters['rowFilter.lote.limite'];
          irregularidade?: parameters['rowFilter.lote.irregularidade'];
          tipo_insercao?: parameters['rowFilter.lote.tipo_insercao'];
          zona_fiscal?: parameters['rowFilter.lote.zona_fiscal'];
          setor_calculo?: parameters['rowFilter.lote.setor_calculo'];
          cpf_cnpj?: parameters['rowFilter.lote.cpf_cnpj'];
          nome?: parameters['rowFilter.lote.nome'];
          patrimonio?: parameters['rowFilter.lote.patrimonio'];
          logradouro?: parameters['rowFilter.lote.logradouro'];
          numero?: parameters['rowFilter.lote.numero'];
          complemento?: parameters['rowFilter.lote.complemento'];
          cep?: parameters['rowFilter.lote.cep'];
          situacao?: parameters['rowFilter.lote.situacao'];
          pedologia?: parameters['rowFilter.lote.pedologia'];
          topografia?: parameters['rowFilter.lote.topografia'];
          geometria?: parameters['rowFilter.lote.geometria'];
          quota_inundacao?: parameters['rowFilter.lote.quota_inundacao'];
          id?: parameters['rowFilter.lote.id'];
        };
        body: {
          /** lote */
          lote?: definitions['lote'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/imobiliario': {
    get: {
      parameters: {
        query: {
          inscricao_cadastral?: parameters['rowFilter.imobiliario.inscricao_cadastral'];
          id_lote?: parameters['rowFilter.imobiliario.id_lote'];
          cadastro?: parameters['rowFilter.imobiliario.cadastro'];
          ativo?: parameters['rowFilter.imobiliario.ativo'];
          inscricao_geo?: parameters['rowFilter.imobiliario.inscricao_geo'];
          unidade?: parameters['rowFilter.imobiliario.unidade'];
          unidade_avaliacao?: parameters['rowFilter.imobiliario.unidade_avaliacao'];
          numero_unidades_avaliacao?: parameters['rowFilter.imobiliario.numero_unidades_avaliacao'];
          pav_numero_total?: parameters['rowFilter.imobiliario.pav_numero_total'];
          cpf_cnpj?: parameters['rowFilter.imobiliario.cpf_cnpj'];
          proprietario?: parameters['rowFilter.imobiliario.proprietario'];
          logradouro?: parameters['rowFilter.imobiliario.logradouro'];
          numero?: parameters['rowFilter.imobiliario.numero'];
          complemento?: parameters['rowFilter.imobiliario.complemento'];
          bairro?: parameters['rowFilter.imobiliario.bairro'];
          cep?: parameters['rowFilter.imobiliario.cep'];
          ano_construcao?: parameters['rowFilter.imobiliario.ano_construcao'];
          pontuacao?: parameters['rowFilter.imobiliario.pontuacao'];
          padrao_acabamento?: parameters['rowFilter.imobiliario.padrao_acabamento'];
          tipologia?: parameters['rowFilter.imobiliario.tipologia'];
          tipo_uso?: parameters['rowFilter.imobiliario.tipo_uso'];
          disposicao?: parameters['rowFilter.imobiliario.disposicao'];
          estado_conservacao?: parameters['rowFilter.imobiliario.estado_conservacao'];
          fracao_ideal?: parameters['rowFilter.imobiliario.fracao_ideal'];
          area_tributavel?: parameters['rowFilter.imobiliario.area_tributavel'];
          estrutura?: parameters['rowFilter.imobiliario.estrutura'];
          material_predominante?: parameters['rowFilter.imobiliario.material_predominante'];
          revestimento_externo?: parameters['rowFilter.imobiliario.revestimento_externo'];
          pintura_externa?: parameters['rowFilter.imobiliario.pintura_externa'];
          cobertura?: parameters['rowFilter.imobiliario.cobertura'];
          esquadrias?: parameters['rowFilter.imobiliario.esquadrias'];
          id?: parameters['rowFilter.imobiliario.id'];
          equacao?: parameters['rowFilter.imobiliario.equacao'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['imobiliario'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** imobiliario */
          imobiliario?: definitions['imobiliario'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          inscricao_cadastral?: parameters['rowFilter.imobiliario.inscricao_cadastral'];
          id_lote?: parameters['rowFilter.imobiliario.id_lote'];
          cadastro?: parameters['rowFilter.imobiliario.cadastro'];
          ativo?: parameters['rowFilter.imobiliario.ativo'];
          inscricao_geo?: parameters['rowFilter.imobiliario.inscricao_geo'];
          unidade?: parameters['rowFilter.imobiliario.unidade'];
          unidade_avaliacao?: parameters['rowFilter.imobiliario.unidade_avaliacao'];
          numero_unidades_avaliacao?: parameters['rowFilter.imobiliario.numero_unidades_avaliacao'];
          pav_numero_total?: parameters['rowFilter.imobiliario.pav_numero_total'];
          cpf_cnpj?: parameters['rowFilter.imobiliario.cpf_cnpj'];
          proprietario?: parameters['rowFilter.imobiliario.proprietario'];
          logradouro?: parameters['rowFilter.imobiliario.logradouro'];
          numero?: parameters['rowFilter.imobiliario.numero'];
          complemento?: parameters['rowFilter.imobiliario.complemento'];
          bairro?: parameters['rowFilter.imobiliario.bairro'];
          cep?: parameters['rowFilter.imobiliario.cep'];
          ano_construcao?: parameters['rowFilter.imobiliario.ano_construcao'];
          pontuacao?: parameters['rowFilter.imobiliario.pontuacao'];
          padrao_acabamento?: parameters['rowFilter.imobiliario.padrao_acabamento'];
          tipologia?: parameters['rowFilter.imobiliario.tipologia'];
          tipo_uso?: parameters['rowFilter.imobiliario.tipo_uso'];
          disposicao?: parameters['rowFilter.imobiliario.disposicao'];
          estado_conservacao?: parameters['rowFilter.imobiliario.estado_conservacao'];
          fracao_ideal?: parameters['rowFilter.imobiliario.fracao_ideal'];
          area_tributavel?: parameters['rowFilter.imobiliario.area_tributavel'];
          estrutura?: parameters['rowFilter.imobiliario.estrutura'];
          material_predominante?: parameters['rowFilter.imobiliario.material_predominante'];
          revestimento_externo?: parameters['rowFilter.imobiliario.revestimento_externo'];
          pintura_externa?: parameters['rowFilter.imobiliario.pintura_externa'];
          cobertura?: parameters['rowFilter.imobiliario.cobertura'];
          esquadrias?: parameters['rowFilter.imobiliario.esquadrias'];
          id?: parameters['rowFilter.imobiliario.id'];
          equacao?: parameters['rowFilter.imobiliario.equacao'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          inscricao_cadastral?: parameters['rowFilter.imobiliario.inscricao_cadastral'];
          id_lote?: parameters['rowFilter.imobiliario.id_lote'];
          cadastro?: parameters['rowFilter.imobiliario.cadastro'];
          ativo?: parameters['rowFilter.imobiliario.ativo'];
          inscricao_geo?: parameters['rowFilter.imobiliario.inscricao_geo'];
          unidade?: parameters['rowFilter.imobiliario.unidade'];
          unidade_avaliacao?: parameters['rowFilter.imobiliario.unidade_avaliacao'];
          numero_unidades_avaliacao?: parameters['rowFilter.imobiliario.numero_unidades_avaliacao'];
          pav_numero_total?: parameters['rowFilter.imobiliario.pav_numero_total'];
          cpf_cnpj?: parameters['rowFilter.imobiliario.cpf_cnpj'];
          proprietario?: parameters['rowFilter.imobiliario.proprietario'];
          logradouro?: parameters['rowFilter.imobiliario.logradouro'];
          numero?: parameters['rowFilter.imobiliario.numero'];
          complemento?: parameters['rowFilter.imobiliario.complemento'];
          bairro?: parameters['rowFilter.imobiliario.bairro'];
          cep?: parameters['rowFilter.imobiliario.cep'];
          ano_construcao?: parameters['rowFilter.imobiliario.ano_construcao'];
          pontuacao?: parameters['rowFilter.imobiliario.pontuacao'];
          padrao_acabamento?: parameters['rowFilter.imobiliario.padrao_acabamento'];
          tipologia?: parameters['rowFilter.imobiliario.tipologia'];
          tipo_uso?: parameters['rowFilter.imobiliario.tipo_uso'];
          disposicao?: parameters['rowFilter.imobiliario.disposicao'];
          estado_conservacao?: parameters['rowFilter.imobiliario.estado_conservacao'];
          fracao_ideal?: parameters['rowFilter.imobiliario.fracao_ideal'];
          area_tributavel?: parameters['rowFilter.imobiliario.area_tributavel'];
          estrutura?: parameters['rowFilter.imobiliario.estrutura'];
          material_predominante?: parameters['rowFilter.imobiliario.material_predominante'];
          revestimento_externo?: parameters['rowFilter.imobiliario.revestimento_externo'];
          pintura_externa?: parameters['rowFilter.imobiliario.pintura_externa'];
          cobertura?: parameters['rowFilter.imobiliario.cobertura'];
          esquadrias?: parameters['rowFilter.imobiliario.esquadrias'];
          id?: parameters['rowFilter.imobiliario.id'];
          equacao?: parameters['rowFilter.imobiliario.equacao'];
        };
        body: {
          /** imobiliario */
          imobiliario?: definitions['imobiliario'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/pessoa': {
    get: {
      parameters: {
        query: {
          nome?: parameters['rowFilter.pessoa.nome'];
          cpf_cnpj?: parameters['rowFilter.pessoa.cpf_cnpj'];
          dt_criacao?: parameters['rowFilter.pessoa.dt_criacao'];
          id?: parameters['rowFilter.pessoa.id'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['pessoa'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** pessoa */
          pessoa?: definitions['pessoa'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          nome?: parameters['rowFilter.pessoa.nome'];
          cpf_cnpj?: parameters['rowFilter.pessoa.cpf_cnpj'];
          dt_criacao?: parameters['rowFilter.pessoa.dt_criacao'];
          id?: parameters['rowFilter.pessoa.id'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          nome?: parameters['rowFilter.pessoa.nome'];
          cpf_cnpj?: parameters['rowFilter.pessoa.cpf_cnpj'];
          dt_criacao?: parameters['rowFilter.pessoa.dt_criacao'];
          id?: parameters['rowFilter.pessoa.id'];
        };
        body: {
          /** pessoa */
          pessoa?: definitions['pessoa'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/imobiliario_pessoa': {
    get: {
      parameters: {
        query: {
          id_pessoa?: parameters['rowFilter.imobiliario_pessoa.id_pessoa'];
          id_imobiliario?: parameters['rowFilter.imobiliario_pessoa.id_imobiliario'];
          id?: parameters['rowFilter.imobiliario_pessoa.id'];
          /** Filtering Columns */
          select?: parameters['select'];
          /** Ordering */
          order?: parameters['order'];
          /** Limiting and Pagination */
          offset?: parameters['offset'];
          /** Limiting and Pagination */
          limit?: parameters['limit'];
        };
        header: {
          /** Limiting and Pagination */
          Range?: parameters['range'];
          /** Limiting and Pagination */
          'Range-Unit'?: parameters['rangeUnit'];
          /** Preference */
          Prefer?: parameters['preferCount'];
        };
      };
      responses: {
        /** OK */
        200: {
          schema: definitions['imobiliario_pessoa'][];
        };
        /** Partial Content */
        206: unknown;
      };
    };
    post: {
      parameters: {
        body: {
          /** imobiliario_pessoa */
          imobiliario_pessoa?: definitions['imobiliario_pessoa'];
        };
        query: {
          /** Filtering Columns */
          select?: parameters['select'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** Created */
        201: unknown;
      };
    };
    delete: {
      parameters: {
        query: {
          id_pessoa?: parameters['rowFilter.imobiliario_pessoa.id_pessoa'];
          id_imobiliario?: parameters['rowFilter.imobiliario_pessoa.id_imobiliario'];
          id?: parameters['rowFilter.imobiliario_pessoa.id'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
    patch: {
      parameters: {
        query: {
          id_pessoa?: parameters['rowFilter.imobiliario_pessoa.id_pessoa'];
          id_imobiliario?: parameters['rowFilter.imobiliario_pessoa.id_imobiliario'];
          id?: parameters['rowFilter.imobiliario_pessoa.id'];
        };
        body: {
          /** imobiliario_pessoa */
          imobiliario_pessoa?: definitions['imobiliario_pessoa'];
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferReturn'];
        };
      };
      responses: {
        /** No Content */
        204: never;
      };
    };
  };
  '/rpc/aval_imoveis': {
    post: {
      parameters: {
        body: {
          args: {
            /** Format: character varying */
            inscricao_imobiliaria: string;
          };
        };
        header: {
          /** Preference */
          Prefer?: parameters['preferParams'];
        };
      };
      responses: {
        /** OK */
        200: unknown;
      };
    };
  };
}

export interface definitions {
  bairro: {
    /** Format: character varying */
    nome?: string;
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id: number;
  };
  testada: {
    /** Format: character varying */
    testada_principal?: string;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `bairro.id`.<fk table='bairro' column='id'/>
     */
    id_bairro?: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `lote.id`.<fk table='lote' column='id'/>
     */
    id_lote?: number;
    /** Format: boolean */
    prncipal?: boolean;
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id: number;
  };
  view_imoveis_totais: {
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_imobiliario?: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_lote?: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id_imobiliario_pessoa?: number;
    /** Format: integer */
    id_pessoa?: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `bairro.id`.<fk table='bairro' column='id'/>
     */
    id_bairro?: number;
    /** Format: character varying */
    cadastro?: string;
    /** Format: character varying */
    inscricao_lote?: string;
    /** Format: character varying */
    ativo?: string;
    /** Format: text */
    inscricao_cadastral_lote?: string;
    /** Format: character varying */
    inscricao_cadastral_imovel?: string;
    /** Format: character varying */
    ocupacao?: string;
    /** Format: character varying */
    area_terreno?: string;
    /** Format: character varying */
    acumulo_metrico?: string;
    /** Format: character varying */
    testada_principal?: string;
    /** Format: character varying */
    calcada?: string;
    /** Format: character varying */
    limite?: string;
    /** Format: character varying */
    irregularidade?: string;
    /** Format: character varying */
    tipo_insercao?: string;
    /** Format: character varying */
    zona_fiscal?: string;
    /** Format: character varying */
    setor_calculo?: string;
    /** Format: character varying */
    nome?: string;
    /** Format: character varying */
    patrimonio?: string;
    /** Format: character varying */
    situacao?: string;
    /** Format: character varying */
    pedologia?: string;
    /** Format: character varying */
    topografia?: string;
    /** Format: character varying */
    geometria?: string;
    /** Format: character varying */
    quota_inundacao?: string;
    /** Format: character varying */
    inscricao_geo?: string;
    /** Format: character varying */
    unidade?: string;
    /** Format: character varying */
    unidade_avaliacao?: string;
    /** Format: character varying */
    numero_unidades_avaliacao?: string;
    /** Format: character varying */
    pav_numero_total?: string;
    /** Format: character varying */
    cpf_cnpj?: string;
    /** Format: character varying */
    proprietario?: string;
    /** Format: character varying */
    logradouro?: string;
    /** Format: character varying */
    numero?: string;
    /** Format: character varying */
    complemento?: string;
    /** Format: character varying */
    bairro?: string;
    /** Format: character varying */
    cep?: string;
    /** Format: character varying */
    ano_construcao?: string;
    /** Format: character varying */
    pontuacao?: string;
    /** Format: character varying */
    padrao_acabamento?: string;
    /** Format: character varying */
    tipologia?: string;
    /** Format: character varying */
    tipo_uso?: string;
    /** Format: character varying */
    disposicao?: string;
    /** Format: character varying */
    estado_conservacao?: string;
    /** Format: character varying */
    fracao_ideal?: string;
    /** Format: character varying */
    area_tributavel?: string;
    /** Format: character varying */
    estrutura?: string;
    /** Format: character varying */
    material_predominante?: string;
    /** Format: character varying */
    revestimento_externo?: string;
    /** Format: character varying */
    pintura_externa?: string;
    /** Format: character varying */
    cobertura?: string;
    /** Format: character varying */
    esquadrias?: string;
    /** Format: ARRAY */
    equacao?: unknown[];
  };
  lote: {
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `bairro.id`.<fk table='bairro' column='id'/>
     */
    id_bairro?: number;
    /** Format: character varying */
    cadastro?: string;
    /** Format: character varying */
    inscricao_lote?: string;
    /** Format: character varying */
    ativo?: string;
    /** Format: character varying */
    inscricao_cadastral?: string;
    /** Format: character varying */
    ocupacao?: string;
    /** Format: character varying */
    area_terreno?: string;
    /** Format: character varying */
    acumulo_metrico?: string;
    /** Format: character varying */
    testada_principal?: string;
    /** Format: character varying */
    calcada?: string;
    /** Format: character varying */
    limite?: string;
    /** Format: character varying */
    irregularidade?: string;
    /** Format: character varying */
    tipo_insercao?: string;
    /** Format: character varying */
    zona_fiscal?: string;
    /** Format: character varying */
    setor_calculo?: string;
    /** Format: character varying */
    cpf_cnpj?: string;
    /** Format: character varying */
    nome?: string;
    /** Format: character varying */
    patrimonio?: string;
    /** Format: character varying */
    logradouro?: string;
    /** Format: character varying */
    numero?: string;
    /** Format: character varying */
    complemento?: string;
    /** Format: character varying */
    cep?: string;
    /** Format: character varying */
    situacao?: string;
    /** Format: character varying */
    pedologia?: string;
    /** Format: character varying */
    topografia?: string;
    /** Format: character varying */
    geometria?: string;
    /** Format: character varying */
    quota_inundacao?: string;
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id: number;
  };
  imobiliario: {
    /** Format: character varying */
    inscricao_cadastral?: string;
    /**
     * Format: integer
     * @description Note:
     * This is a Foreign Key to `lote.id`.<fk table='lote' column='id'/>
     */
    id_lote?: number;
    /** Format: character varying */
    cadastro?: string;
    /** Format: character varying */
    ativo?: string;
    /** Format: character varying */
    inscricao_geo?: string;
    /** Format: character varying */
    unidade?: string;
    /** Format: character varying */
    unidade_avaliacao?: string;
    /** Format: character varying */
    numero_unidades_avaliacao?: string;
    /** Format: character varying */
    pav_numero_total?: string;
    /** Format: character varying */
    cpf_cnpj?: string;
    /** Format: character varying */
    proprietario?: string;
    /** Format: character varying */
    logradouro?: string;
    /** Format: character varying */
    numero?: string;
    /** Format: character varying */
    complemento?: string;
    /** Format: character varying */
    bairro?: string;
    /** Format: character varying */
    cep?: string;
    /** Format: character varying */
    ano_construcao?: string;
    /** Format: character varying */
    pontuacao?: string;
    /** Format: character varying */
    padrao_acabamento?: string;
    /** Format: character varying */
    tipologia?: string;
    /** Format: character varying */
    tipo_uso?: string;
    /** Format: character varying */
    disposicao?: string;
    /** Format: character varying */
    estado_conservacao?: string;
    /** Format: character varying */
    fracao_ideal?: string;
    /** Format: character varying */
    area_tributavel?: string;
    /** Format: character varying */
    estrutura?: string;
    /** Format: character varying */
    material_predominante?: string;
    /** Format: character varying */
    revestimento_externo?: string;
    /** Format: character varying */
    pintura_externa?: string;
    /** Format: character varying */
    cobertura?: string;
    /** Format: character varying */
    esquadrias?: string;
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id: number;
    /** Format: ARRAY */
    equacao?: unknown[];
  };
  pessoa: {
    /** Format: character varying */
    nome?: string;
    /** Format: character varying */
    cpf_cnpj?: string;
    /**
     * Format: timestamp without time zone
     * @default CURRENT_TIMESTAMP
     */
    dt_criacao?: string;
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id: number;
  };
  imobiliario_pessoa: {
    /** Format: integer */
    id_pessoa?: number;
    /** Format: integer */
    id_imobiliario?: number;
    /**
     * Format: integer
     * @description Note:
     * This is a Primary Key.<pk/>
     */
    id: number;
  };
}

export interface parameters {
  /**
   * @description Preference
   * @enum {string}
   */
  preferParams: 'params=single-object';
  /**
   * @description Preference
   * @enum {string}
   */
  preferReturn: 'return=representation' | 'return=minimal' | 'return=none';
  /**
   * @description Preference
   * @enum {string}
   */
  preferCount: 'count=none';
  /** @description Filtering Columns */
  select: string;
  /** @description On Conflict */
  on_conflict: string;
  /** @description Ordering */
  order: string;
  /** @description Limiting and Pagination */
  range: string;
  /**
   * @description Limiting and Pagination
   * @default items
   */
  rangeUnit: string;
  /** @description Limiting and Pagination */
  offset: string;
  /** @description Limiting and Pagination */
  limit: string;
  /** @description bairro */
  'body.bairro': definitions['bairro'];
  /** Format: character varying */
  'rowFilter.bairro.nome': string;
  /** Format: integer */
  'rowFilter.bairro.id': string;
  /** @description testada */
  'body.testada': definitions['testada'];
  /** Format: character varying */
  'rowFilter.testada.testada_principal': string;
  /** Format: integer */
  'rowFilter.testada.id_bairro': string;
  /** Format: integer */
  'rowFilter.testada.id_lote': string;
  /** Format: boolean */
  'rowFilter.testada.prncipal': string;
  /** Format: integer */
  'rowFilter.testada.id': string;
  /** @description view_imoveis_totais */
  'body.view_imoveis_totais': definitions['view_imoveis_totais'];
  /** Format: integer */
  'rowFilter.view_imoveis_totais.id_imobiliario': string;
  /** Format: integer */
  'rowFilter.view_imoveis_totais.id_lote': string;
  /** Format: integer */
  'rowFilter.view_imoveis_totais.id_imobiliario_pessoa': string;
  /** Format: integer */
  'rowFilter.view_imoveis_totais.id_pessoa': string;
  /** Format: integer */
  'rowFilter.view_imoveis_totais.id_bairro': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.cadastro': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.inscricao_lote': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.ativo': string;
  /** Format: text */
  'rowFilter.view_imoveis_totais.inscricao_cadastral_lote': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.inscricao_cadastral_imovel': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.ocupacao': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.area_terreno': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.acumulo_metrico': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.testada_principal': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.calcada': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.limite': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.irregularidade': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.tipo_insercao': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.zona_fiscal': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.setor_calculo': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.nome': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.patrimonio': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.situacao': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.pedologia': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.topografia': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.geometria': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.quota_inundacao': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.inscricao_geo': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.unidade': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.unidade_avaliacao': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.numero_unidades_avaliacao': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.pav_numero_total': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.cpf_cnpj': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.proprietario': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.logradouro': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.numero': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.complemento': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.bairro': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.cep': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.ano_construcao': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.pontuacao': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.padrao_acabamento': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.tipologia': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.tipo_uso': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.disposicao': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.estado_conservacao': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.fracao_ideal': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.area_tributavel': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.estrutura': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.material_predominante': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.revestimento_externo': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.pintura_externa': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.cobertura': string;
  /** Format: character varying */
  'rowFilter.view_imoveis_totais.esquadrias': string;
  /** Format: ARRAY */
  'rowFilter.view_imoveis_totais.equacao': string;
  /** @description lote */
  'body.lote': definitions['lote'];
  /** Format: integer */
  'rowFilter.lote.id_bairro': string;
  /** Format: character varying */
  'rowFilter.lote.cadastro': string;
  /** Format: character varying */
  'rowFilter.lote.inscricao_lote': string;
  /** Format: character varying */
  'rowFilter.lote.ativo': string;
  /** Format: character varying */
  'rowFilter.lote.inscricao_cadastral': string;
  /** Format: character varying */
  'rowFilter.lote.ocupacao': string;
  /** Format: character varying */
  'rowFilter.lote.area_terreno': string;
  /** Format: character varying */
  'rowFilter.lote.acumulo_metrico': string;
  /** Format: character varying */
  'rowFilter.lote.testada_principal': string;
  /** Format: character varying */
  'rowFilter.lote.calcada': string;
  /** Format: character varying */
  'rowFilter.lote.limite': string;
  /** Format: character varying */
  'rowFilter.lote.irregularidade': string;
  /** Format: character varying */
  'rowFilter.lote.tipo_insercao': string;
  /** Format: character varying */
  'rowFilter.lote.zona_fiscal': string;
  /** Format: character varying */
  'rowFilter.lote.setor_calculo': string;
  /** Format: character varying */
  'rowFilter.lote.cpf_cnpj': string;
  /** Format: character varying */
  'rowFilter.lote.nome': string;
  /** Format: character varying */
  'rowFilter.lote.patrimonio': string;
  /** Format: character varying */
  'rowFilter.lote.logradouro': string;
  /** Format: character varying */
  'rowFilter.lote.numero': string;
  /** Format: character varying */
  'rowFilter.lote.complemento': string;
  /** Format: character varying */
  'rowFilter.lote.cep': string;
  /** Format: character varying */
  'rowFilter.lote.situacao': string;
  /** Format: character varying */
  'rowFilter.lote.pedologia': string;
  /** Format: character varying */
  'rowFilter.lote.topografia': string;
  /** Format: character varying */
  'rowFilter.lote.geometria': string;
  /** Format: character varying */
  'rowFilter.lote.quota_inundacao': string;
  /** Format: integer */
  'rowFilter.lote.id': string;
  /** @description imobiliario */
  'body.imobiliario': definitions['imobiliario'];
  /** Format: character varying */
  'rowFilter.imobiliario.inscricao_cadastral': string;
  /** Format: integer */
  'rowFilter.imobiliario.id_lote': string;
  /** Format: character varying */
  'rowFilter.imobiliario.cadastro': string;
  /** Format: character varying */
  'rowFilter.imobiliario.ativo': string;
  /** Format: character varying */
  'rowFilter.imobiliario.inscricao_geo': string;
  /** Format: character varying */
  'rowFilter.imobiliario.unidade': string;
  /** Format: character varying */
  'rowFilter.imobiliario.unidade_avaliacao': string;
  /** Format: character varying */
  'rowFilter.imobiliario.numero_unidades_avaliacao': string;
  /** Format: character varying */
  'rowFilter.imobiliario.pav_numero_total': string;
  /** Format: character varying */
  'rowFilter.imobiliario.cpf_cnpj': string;
  /** Format: character varying */
  'rowFilter.imobiliario.proprietario': string;
  /** Format: character varying */
  'rowFilter.imobiliario.logradouro': string;
  /** Format: character varying */
  'rowFilter.imobiliario.numero': string;
  /** Format: character varying */
  'rowFilter.imobiliario.complemento': string;
  /** Format: character varying */
  'rowFilter.imobiliario.bairro': string;
  /** Format: character varying */
  'rowFilter.imobiliario.cep': string;
  /** Format: character varying */
  'rowFilter.imobiliario.ano_construcao': string;
  /** Format: character varying */
  'rowFilter.imobiliario.pontuacao': string;
  /** Format: character varying */
  'rowFilter.imobiliario.padrao_acabamento': string;
  /** Format: character varying */
  'rowFilter.imobiliario.tipologia': string;
  /** Format: character varying */
  'rowFilter.imobiliario.tipo_uso': string;
  /** Format: character varying */
  'rowFilter.imobiliario.disposicao': string;
  /** Format: character varying */
  'rowFilter.imobiliario.estado_conservacao': string;
  /** Format: character varying */
  'rowFilter.imobiliario.fracao_ideal': string;
  /** Format: character varying */
  'rowFilter.imobiliario.area_tributavel': string;
  /** Format: character varying */
  'rowFilter.imobiliario.estrutura': string;
  /** Format: character varying */
  'rowFilter.imobiliario.material_predominante': string;
  /** Format: character varying */
  'rowFilter.imobiliario.revestimento_externo': string;
  /** Format: character varying */
  'rowFilter.imobiliario.pintura_externa': string;
  /** Format: character varying */
  'rowFilter.imobiliario.cobertura': string;
  /** Format: character varying */
  'rowFilter.imobiliario.esquadrias': string;
  /** Format: integer */
  'rowFilter.imobiliario.id': string;
  /** Format: ARRAY */
  'rowFilter.imobiliario.equacao': string;
  /** @description pessoa */
  'body.pessoa': definitions['pessoa'];
  /** Format: character varying */
  'rowFilter.pessoa.nome': string;
  /** Format: character varying */
  'rowFilter.pessoa.cpf_cnpj': string;
  /** Format: timestamp without time zone */
  'rowFilter.pessoa.dt_criacao': string;
  /** Format: integer */
  'rowFilter.pessoa.id': string;
  /** @description imobiliario_pessoa */
  'body.imobiliario_pessoa': definitions['imobiliario_pessoa'];
  /** Format: integer */
  'rowFilter.imobiliario_pessoa.id_pessoa': string;
  /** Format: integer */
  'rowFilter.imobiliario_pessoa.id_imobiliario': string;
  /** Format: integer */
  'rowFilter.imobiliario_pessoa.id': string;
}

export interface operations {}

export interface external {}
